import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {}

const Pin: React.FC<Props> = (props) => {
    return (
        <svg width={12} height={13} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M4.61 7.98L1 11.59M2.11 5.195L7.217 10.3l.942-.943-.217-2.102L11 4.659 7.75 1.411 5.156 4.47l-2.103-.218-.942.943z"
                stroke="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Pin;
